<section class="section" id="form-landing-fru" [ngClass]="{
  'zero-padding': !officeStatus?.answer,
  'rocket-mortgage': best?.lender == 26491 && false,
  'loan-depot': best?.lender == 75 && false,
  'journey-lending': best?.lender == 43103 && false,
  'ab-new-design-loan-type': newDesignLoanTypeABTest,
}">
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-four-fifths form-bg">
        <div *ngIf="!newDesignLoanTypeABTest" class="secure_form"><span><i class="fa fa-lock fa-lg"></i> Secure Form</span></div>

        <h2 class="has-text-centered has-text-grey-dark has-text-weight-semibold">
          Choose loan type
        </h2>

        <div *ngIf="!newDesignLoanTypeABTest" class="buttons is-centered">

          <button (click)="redirectForm('refinance')"
            [class]="{button: true, 'icon-button': true, 'icon-button-refinance': true}"
            [style.order]="btnOrder.refinance"
          ></button>
          <button *ngIf="isPurchaseEnabled" (click)="redirectForm('purchase')"
            [class]="{button: true, 'icon-button': true, 'icon-button-purchase': true}"
            [style.order]="btnOrder.purchase"
          ></button>
          <button (click)="redirectForm('refinance', 'heloc', 'homeequity')"
            [class]="{button: true, 'icon-button': true, 'icon-button-heloc': true}"
            [style.order]="btnOrder.homeequity"
          ></button>

          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'"
            (click)="redirectForm('refinance', 'heloc', 'homeequity')"
            [class]="{button: true, 'icon-button': true, 'icon-button-2nd-mortgage-loan': true}"
            [style.order]="btnOrder.second_mortgage"
          ></button>
          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'"
            (click)="redirectForm('refinance', 'heloc', 'homeequity')"
            [class]="{button: true, 'icon-button': true, 'icon-button-heloc-card': true}"
            [style.order]="btnOrder.heloc_card"
          ></button>
          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'"
            (click)="redirectForm('refinance', 'heloc', 'homeequity')"
            [class]="{button: true, 'icon-button': true, 'new-icon-button-heloc-abtest': true}"
            [style.order]="btnOrder.heloc"
          ></button>

          <button (click)="redirectForm('refinance', 'cashout')"
            [class]="{button: true, 'icon-button': true, 'icon-button-cash-out': true}"
            [style.order]="btnOrder.cashout"
          ></button>
          <button (click)="redirectForm('refinance', 'homeimprovement')"
            [class]="{button: true, 'icon-button': true, 'icon-button-home-improvement': true}"
            [style.order]="btnOrder.homeimprovement"
          ></button>

          <div [style.order]="btnOrder.separator" style="width: 100%; text-align: center;margin-top:10px;margin-bottom: 10px;" *ngIf="!isPurchaseEnabled">
            <h3>OR</h3>
            <h4>Shop Other Lenders</h4>
          </div>

          <button *ngIf="!isPurchaseEnabled" (click)="redirectForm('purchase')"
            [class]="{button: true, 'icon-button': true, 'icon-button-purchase': true}"
            [style.order]="btnOrder.purchase"
          ></button>

        </div>

        <div *ngIf="newDesignLoanTypeABTest" class="buttons is-centered">
          <button (click)="redirectForm('refinance')" class="form-button" [style.order]="btnOrder.refinance">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m270.7 189.7l-76.4-67.5-76.5 67.5"/>
                <path class="s0" d="m248.1 251v-57l-53.8-47.9-53.9 47.9v57.1z"/>
                <path class="s0" fill-rule="evenodd" d="m175.6 251.1v-43.4h37.3v43.3"/>
                <path class="s0" fill-rule="evenodd" d="m319.2 191.9c0 69.7-56.5 126.1-126.1 126.1-38 0-72-16.7-95.1-43.2l-1.2-1"/>
                <path class="s0" fill-rule="evenodd" d="m96.8 321.8v-48h47.1"/>
                <path class="s0" fill-rule="evenodd" d="m65 192.8c0-69.7 56.5-126.1 126.2-126.1 37.9 0 72 16.7 95.1 43.2l1.2 1"/>
                <path class="s0" fill-rule="evenodd" d="m287.5 62.9v48h-47.2"/>
              </g>
            </svg>
            Refinance
          </button>

          <button *ngIf="isPurchaseEnabled" (click)="redirectForm('purchase')" class="form-button" [style.order]="btnOrder.purchase">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path class="s0" d="m273 264.8l-152.1 29.5-15.9-81.7 152.2-29.5z"/>
                <path class="s0" fill-rule="evenodd" d="m135 258.7c1.1 4.6 5.6 7.5 10.3 6.6 4.8-0.9 7.9-5.6 7-10.4-0.9-4.7-5.6-7.9-10.4-6.9-4.8 0.9-9.4-2.2-10.3-7-1-4.8 2.2-9.5 6.9-10.4 4.4-0.8 8.6 1.6 10 5.7"/>
                <path class="s0" fill-rule="evenodd" d="m191.1 256.4l-19.1-31.7c-0.1-0.2-0.4-0.1-0.4 0.1l-5.9 36.5"/>
                <path class="s0" fill-rule="evenodd" d="m167.7 249l17-3.3"/>
                <path class="s0" fill-rule="evenodd" d="m196.3 219.4l6.8 34.7 16.5-3.2"/>
                <path class="s0" fill-rule="evenodd" d="m250.4 244.9l-20.3 3.9-6.7-34.7 20.2-3.9"/>
                <path class="s0" fill-rule="evenodd" d="m226.7 231.4l17.8-3.5"/>
                <path class="s0" fill-rule="evenodd" d="m-132.1 419v-5-2.2-2.8"/>
                <path class="s0" fill-rule="evenodd" d="m-132.1 461.7v4.4 0.7 2.9 2.3"/>
              </g>
            </svg>
            Purchase
          </button>

          <button (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="form-button" [style.order]="btnOrder.homeequity">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path class="s0" fill-rule="evenodd" d="m173.5 247.9c0.4 10.5 9 18.8 19.6 18.8 10.9 0 19.7-8.8 19.7-19.7 0-10.9-8.8-19.7-19.7-19.7-10.8 0-19.7-8.8-19.7-19.7 0-10.9 8.9-19.7 19.7-19.7 9.9 0 18 7.2 19.5 16.6"/>
                <path class="s0" fill-rule="evenodd" d="m193.1 187.9v-9.3-4-5.1"/>
                <path class="s0" fill-rule="evenodd" d="m193.1 264.7v8.2 1.2 5.5 4.1"/>
              </g>
            </svg>
            Home Equity
          </button>

          <!-- 2nd-mortgage-loan.svg -->
          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'" (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="form-button" [style.order]="btnOrder.second_mortgage">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>
                .s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8; }
                .s1 { fill: currentColor; }
              </style>
              <g>
                <path fill-rule="evenodd" class="s0" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path fill-rule="evenodd" class="s0" d="m176.6 289.5v21.8h-33.2v-21.8z"/>
                <path fill-rule="evenodd" class="s0" d="m209.6 289.5v21.8h-33.2v-21.8z"/>
                <path fill-rule="evenodd" class="s0" d="m241.6 289.5v21.8h-33.2v-21.8z"/>
                <path fill-rule="evenodd" class="s0" d="m192.6 267.5v21.8h-33.2v-21.8z"/>
                <path fill-rule="evenodd" class="s0" d="m224.6 267.5v21.8h-33.2v-21.8z"/>
                <path class="s0" d="m229.5 177.1c20.3 20.4 20.3 53.3 0 73.7-20.3 20.3-53.3 20.3-73.6 0-20.3-20.4-20.3-53.3 0-73.7 20.3-20.3 53.3-20.3 73.6 0z"/>
                <path class="s1" d="m189.4 238.9l-6.1 0.1 21.7-23.4c5.6-5.9 7.6-9.8 7.6-17v-1.2c0-9.8-6.7-18-21.1-18-14.5 0-21.1 7.5-21.1 21.3v1.8h8.7c0-11 4.2-15.3 12.1-15.3h0.6c7.2 0 12 4.2 12 11.7v0.8c0 4.5-1.5 7.4-5.8 11.9l-27.6 29.7v5.4h42.2v-7.8z"/>
              </g>
            </svg>
            2nd Mortgage
          </button>

          <!-- heloc-card.svg -->
          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'" (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="form-button" [style.order]="btnOrder.heloc_card">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>
                .s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }
              </style>
              <rect x="52" y="96" width="260" height="192" rx="16" ry="16" class="s0"/>
              <line x1="52" y1="144" x2="302" y2="144" class="s0"/>
              <rect x="92" y="192" width="48" height="48" rx="4" ry="4" class="s0"/>
              <line x1="164" y1="208" x2="272" y2="208" class="s0"/>
              <line x1="164" y1="232" x2="248" y2="232" class="s0"/>
            </svg>
            HELOC Card
          </button>

          <!-- heloc.svg -->
          <button *ngIf="loanType == 'home-equity' || loanType == 'heloc'" (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="form-button" [style.order]="btnOrder.heloc">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>
                .s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8; }
                .s1 { fill: currentColor; }
              </style>
              <g>
                <path fill-rule="evenodd" class="s0" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path fill-rule="evenodd" class="s0" d="m180 259.6c0.3 6.4 5.6 11.5 12 11.5 6.7 0 12-5.4 12-12 0-6.7-5.3-12.1-12-12.1-6.6 0-12-5.3-12-12 0-6.6 5.4-12 12-12 6 0 11 4.4 11.9 10.1"/>
                <path fill-rule="evenodd" class="s0" d="m192 223v-5.7-2.5-3.1"/>
                <path fill-rule="evenodd" class="s0" d="m192 269.8v5 0.8 3.3 2.5"/>
                <path class="s0" d="m174.5 164h35c1.4 0 2.7 0.3 4 0.8 1.3 0.5 2.4 1.3 3.4 2.3 1 1 1.8 2.1 2.3 3.4 0.5 1.3 0.8 2.6 0.8 4 0 3.2-0.6 6.4-1.9 9.4-1.2 2.9-3 5.6-5.3 7.9-2.3 2.3-5 4.1-7.9 5.3-3 1.3-6.2 1.9-9.4 1.9h-7c-3.2 0-6.4-0.6-9.4-1.9-2.9-1.2-5.6-3-7.9-5.3-2.3-2.3-4.1-5-5.3-7.9-1.3-3-1.9-6.2-1.9-9.4 0-1.4 0.3-2.7 0.8-4 0.5-1.3 1.3-2.4 2.3-3.4 1-1 2.1-1.8 3.4-2.3 1.3-0.5 2.6-0.8 4-0.8z"/>
                <path class="s0" d="m136 263v-7c0-14.9 5.9-29.1 16.4-39.6 10.5-10.5 24.7-16.4 39.6-16.4 14.9 0 29.1 5.9 39.6 16.4 10.5 10.5 16.4 24.7 16.4 39.6v7c0 3.7-0.7 7.3-2.1 10.7-1.4 3.4-3.5 6.5-6.1 9.1-2.6 2.6-5.7 4.7-9.1 6.1-3.4 1.4-7 2.1-10.7 2.1h-56c-3.7 0-7.3-0.7-10.7-2.1-3.4-1.4-6.5-3.5-9.1-6.1-2.6-2.6-4.7-5.7-6.1-9.1-1.4-3.4-2.1-7-2.1-10.7z"/>
              </g>
            </svg>
            HELOC
          </button>

          <button (click)="redirectForm('refinance', 'cashout')" class="form-button" [style.order]="btnOrder.cashout">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m159.8 202.3c0.4 9.3 8.1 16.8 17.6 16.8 9.7 0 17.6-7.9 17.6-17.6 0-9.8-7.9-17.6-17.6-17.6-9.8 0-17.7-7.9-17.7-17.6 0-9.8 7.9-17.7 17.7-17.7 8.7 0 16 6.5 17.4 14.9"/>
                <path class="s0" fill-rule="evenodd" d="m177.4 148.6v-8.2-3.7-4.6"/>
                <path class="s0" fill-rule="evenodd" d="m177.4 219.1v7.3 1.1 4.9 3.7"/>
                <path class="s0" d="m289.9 256.5h-221.4v-145.2h221.4z"/>
                <path class="s0" fill-rule="evenodd" d="m108.3 111.3v15.9c0 14.9-12.1 26.9-26.9 26.9h-12.9"/>
                <path class="s0" fill-rule="evenodd" d="m108.3 256.5v-14.7c0-14.9-12.1-27-26.9-27h-12.9"/>
                <path class="s0" fill-rule="evenodd" d="m249.6 256.5v-15.9c0-14.9 12.1-27 27-27h12.8"/>
                <path class="s0" fill-rule="evenodd" d="m249.6 111.3v14.7c0 14.9 12.1 27 27 27h12.8"/>
                <path class="s0" fill-rule="evenodd" d="m105.4 183.9h29"/>
                <path class="s0" fill-rule="evenodd" d="m220.4 183.9h28.9"/>
                <path class="s0" fill-rule="evenodd" d="m101.9 289.4h219.2v-149"/>
              </g>
            </svg>
            Cash Out
          </button>
          <button (click)="redirectForm('refinance', 'homeimprovement')" class="form-button" [style.order]="btnOrder.homeimprovement">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path class="s0" d="m190.8 326.2h-1.6c-3.4 0-6.2-2.8-6.2-6.2v-36.3h14v36.3c0 3.4-2.8 6.2-6.2 6.2z"/>
                <path class="s0" d="m238.3 221.4h-96c-3.8 0-6.9-3.1-6.9-7v-19.7c0-3.8 3.1-7 6.9-7h96c3.8 0 7 3.2 7 7v19.7c0 3.9-3.2 7-7 7z"/>
                <path class="s0" fill-rule="evenodd" d="m135.4 204.6h-7.7"/>
                <path class="s0" fill-rule="evenodd" d="m135.4 209.8v48.9c0 3.5 2.8 6.3 6.3 6.3 3.5 0 6.3-2.8 6.3-6.3v-21.1c0-3.7 3-6.7 6.7-6.7 3.7 0 6.7 3 6.7 6.7v9.8c0 3.5 2.8 6.4 6.4 6.4 3.5 0 6.3-2.9 6.3-6.4v-12c0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.3 2.9 6.3 6.4v2.8c0 3.7 3 6.7 6.7 6.7 3.7 0 6.7-3 6.7-6.7v-16.8"/>
                <path class="s0" fill-rule="evenodd" d="m190.3 283.7v-10.1c0-6.3 4.5-11.8 10.7-13.1l46.3-9.5c4.7-0.9 8.1-5.1 8.1-9.9v-28.7c0-4.3-3.5-7.8-7.8-7.8h-2.3"/>
                <path class="s0" fill-rule="evenodd" d="m-83.5 475.5v-5.2-2.3-2.9"/>
                <path class="s0" fill-rule="evenodd" d="m-100.5 496.3v4.7 0.7 3 2.4"/>
              </g>
            </svg>
            Home Improvement
          </button>

          <div [style.order]="btnOrder.separator" style="width: 100%; text-align: center;" *ngIf="!isPurchaseEnabled">
            <h3 style="line-height:1.2em;width: 100%;color: #333;">OR</h3>
            <h4 style="line-height:1.2em;width: 100%;color: #333;">Shop Other Lenders</h4>
          </div>

          <button *ngIf="!isPurchaseEnabled" (click)="redirectForm('purchase')" class="form-button" [style.order]="10">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" width="64" height="64">
              <style>.s0 { fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 8 }</style>
              <g>
                <path class="s0" fill-rule="evenodd" d="m338.5 195.2l-145.4-128.4-145.4 128.4"/>
                <path class="s0" d="m295.5 311.8v-108.5l-102.2-91-102.6 91.1v108.5z"/>
                <path class="s0" d="m273 264.8l-152.1 29.5-15.9-81.7 152.2-29.5z"/>
                <path class="s0" fill-rule="evenodd" d="m135 258.7c1.1 4.6 5.6 7.5 10.3 6.6 4.8-0.9 7.9-5.6 7-10.4-0.9-4.7-5.6-7.9-10.4-6.9-4.8 0.9-9.4-2.2-10.3-7-1-4.8 2.2-9.5 6.9-10.4 4.4-0.8 8.6 1.6 10 5.7"/>
                <path class="s0" fill-rule="evenodd" d="m191.1 256.4l-19.1-31.7c-0.1-0.2-0.4-0.1-0.4 0.1l-5.9 36.5"/>
                <path class="s0" fill-rule="evenodd" d="m167.7 249l17-3.3"/>
                <path class="s0" fill-rule="evenodd" d="m196.3 219.4l6.8 34.7 16.5-3.2"/>
                <path class="s0" fill-rule="evenodd" d="m250.4 244.9l-20.3 3.9-6.7-34.7 20.2-3.9"/>
                <path class="s0" fill-rule="evenodd" d="m226.7 231.4l17.8-3.5"/>
                <path class="s0" fill-rule="evenodd" d="m-132.1 419v-5-2.2-2.8"/>
                <path class="s0" fill-rule="evenodd" d="m-132.1 461.7v4.4 0.7 2.9 2.3"/>
              </g>
            </svg>
            Purchase
          </button>
        </div>

        <p style="text-align: right">
          &nbsp;
        </p>
        <app-customer-review *ngIf="CustomReviews"></app-customer-review>
      </div>
    </div>
  </div>
</section>
